import { DashboardShell } from '@pwa/components/dashboard/dashboard-shell';
import { orgQueries } from '@pwa/queries/org/org';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/org/$orgId')({
	loader: async ({ context, params }) => {
		const orgData = await context.queryClient.fetchQuery(orgQueries.detail(params.orgId));
		if (!orgData.organization) {
			throw redirect({ to: '/', replace: true });
		}
		return { organization: orgData.organization };
	},
	component: RouteComponent,
});

function RouteComponent() {
	const { organization } = Route.useLoaderData();
	const orgName =
		organization && typeof organization === 'object' && 'name' in organization ? String(organization.name) : null;

	return (
		<DashboardShell orgName={orgName}>
			<Outlet />
		</DashboardShell>
	);
}
